import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SEO from "../components/shared/SEO";
import DashboardNavbar from "../components/shared/DashboardNavbar";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import DraftBlogHeader from "../components/dashboard/DraftBlogHeader";
import BlogBannerUpload from "../components/dashboard/BlogBannerUpload";
import BlogTitleInput from "../components/dashboard/BlogTitleInput";
import BlogEditor from "../components/dashboard/BlogEditor";
import BlogEditorActions from "../components/dashboard/BlogEditorActions";

export default function EditDraft() {
  const navigate = useNavigate();
  const location = useLocation();
  const draft = location.state?.draft;

  const [bannerImage, setBannerImage] = useState(draft?.image || null);
  const [title, setTitle] = useState(draft?.title || "");

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title="Draft Blog | SoloConnect"
        description="Continue editing your draft travel blog on SoloConnect."
        keywords="draft blog, edit blog, blog editor, SoloConnect"
      />
      <DashboardNavbar />

      <main className="flex-grow bg-[#FAFAFB]">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-8">
          <DraftBlogHeader />

          <div className="flex flex-col gap-6">
            <BlogBannerUpload
              image={bannerImage}
              onImageChange={setBannerImage}
            />
            <BlogTitleInput title={title} onTitleChange={setTitle} />
            <BlogEditor
              initialContent={draft?.desc ? `<p>${draft.desc}</p>` : ""}
            />
          </div>

          <BlogEditorActions
            onSaveDraft={() => {}}
            onPublish={() => navigate("/dashboard/my-blogs")}
          />
        </div>
      </main>

      <div className="hidden md:block">
        <SoloConnectFooter />
      </div>
      <div className="block md:hidden">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
